import { CollectionCard } from 'components/CollectionCard/CollectionCard';

import type { UnifiedCollectionItem } from './types.d';

import type { ReactNode } from 'react';
import { spring, StaggeredMotion } from 'react-motion';

export type {
  ImageItem as ImageCollectionItem,
  VideoItem as VideoCollectionItem,
  GenericItem as CollectionItem,
} from './types.d';
export type { UnifiedCollectionItem };

export interface CollectionProps {
  items: UnifiedCollectionItem[];
  header?: string;
  subheader?: ReactNode;
  disabledImageShare?: boolean;
}

function getFancyGroupKey(item: UnifiedCollectionItem): string {
  if (item.type === 'photo') return item.chapter.chapterTitle;
  return item.url;
}

export function Collection({ items, header, subheader, disabledImageShare = false }: CollectionProps) {
  if (!items.length) return null;

  const startingValues = Array.from({ length: items.length }, () => ({ pos: 0 }));

  return (
    <div className="collection">
      {header && (
        <div className="collection__header">
          <h3 className="global__text--title">{header}</h3>
          {subheader && <h5>{subheader}</h5>}
        </div>
      )}
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={(prevInterpolatedStyles) =>
          prevInterpolatedStyles.map((_, i) =>
            i === 0
              ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
              : { pos: spring(prevInterpolatedStyles[i - 1]?.pos ?? 0, { stiffness: 320, damping: 28 }) },
          )
        }
      >
        {(styles) => (
          <div className="collection__grid">
            {items.map((item, index) => (
              <CollectionCard
                key={item.type === 'video' ? item.linkJW : item.pageID}
                item={item}
                opacity={styles[index]?.pos ?? 0}
                fancyGroupKey={getFancyGroupKey(item)}
                disabledImageShare={disabledImageShare}
              />
            ))}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
}
